
export default {
	computed: {
		deviceHeight () {
			return document.body.clientHeight + 'px'
		}
	}
}



// WEBPACK FOOTER //
// ./src/lib/czqui/layout/index.js